import { contains } from 'ramda'
import { isEmpty, isObject, transform } from 'lodash'

export const isSortOrder = order => contains(order, ['asc', 'desc'])
export const attribute = (value) => {
  if (value === '' || value === undefined || value === null) {
    return '-'
  }
  return value
}
export const nullableSanitize = (value) => {
  if (value === '' || value === undefined || value === null) {
    return 'Todos'
  }
  return value
}

export const omit = function (obj) {
  function omitFromObject (obj) {
    return transform(obj, function (result, value, key) {
      if (value === '' || value === undefined || value === null) {
        return
      }

      let newValue
      if (value instanceof Date) {
        newValue = value.toISOString()
      } else {
        newValue = isObject(value) ? omitFromObject(value) : value
      }

      if (!(newValue === '' || newValue === undefined || newValue === null || (isObject(newValue) && isEmpty(newValue)))) {
        result[key] = newValue
      }
    })
  }

  return omitFromObject(obj)
}

export const getAllUrlParams = () => {
  var queryString = window.location.href.split('?')[1]

  var obj = {}

  if (queryString) {
    queryString = queryString.split('#')[0]

    var arr = queryString.split('&')

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split('=')

      var paramNum
      var paramName = a[0].replace(/\[\d*\]/, function (v) {
        paramNum = v.slice(1, -1)
        return ''
      })

      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1]

      if (obj[paramName]) {
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]]
        }
        if (typeof paramNum === 'undefined') {
          obj[paramName].push(paramValue)
        } else {
          obj[paramName][paramNum] = paramValue
        }
      } else {
        obj[paramName] = paramValue
      }
    }
  }

  return obj
}



// WEBPACK FOOTER //
// ./src/helper.js